module.exports = __webpack_public_path__ + "static/media/accident_per_dist.f44e52b4.png";